import { buildPaths } from '@front/logic/others/buildPaths'

const AdminRoutes = buildPaths({
  Admin: {
    Login: {},
  },
})

export const AdminRoutesVariables = {
  Admin: AdminRoutes.Admin.path,
  AdminLogin: AdminRoutes.Admin.Login.path,
}
